import script from "./GraphHouses.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphHouses.vue?vue&type=script&setup=true&lang=js"

import "./GraphHouses.vue?vue&type=style&index=0&id=110da6f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-110da6f8"]])

export default __exports__